// import React from "react";
// import { Box, Button } from "@mui/material";

// const AssignmentPagination = ({ page, totalPages, handlePageChange}) => {

//   const renderPageNumbers = () => {
//     const pages = [];
//     const maxVisible = 5;

//     if (totalPages <= maxVisible) {
//       for (let i = 1; i <= totalPages; i++) pages.push(i);
//     } else {
//       if (page <= 3) {
//         pages.push(1, 2, 3, 4, "...", totalPages);
//       } else if (page >= totalPages - 2) {
//         pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
//       } else {
//         pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
//       }
//     }
//     return pages;
//   };


//   return (
//     <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 2, gap: 1 }}>
//       {/* Previous Button */}
//       <Button
//         className="btn-negative"
//         variant="outlined"
//         disabled={page === 1}
//         onClick={() => handlePageChange(page - 1)}
//       >
//         Previous
//       </Button>

//       {/* Page Numbers */}
//       {renderPageNumbers().map((pageNum, index) => (
//         <Button
//           key={index}
//           variant={pageNum === page ? "contained" : "outlined"}
//           onClick={() => typeof pageNum === "number" && handlePageChange(pageNum)}
//           disabled={pageNum === "..."}
//           className={`change-assignment-type-btn ${pageNum === page ? "active" : ""
//             }`}
//         >
//           {pageNum}
//         </Button>
//       ))}

//       {/* Next Button */}
//       <Button
//         className="btn-negative"
//         variant="outlined"
//         disabled={page === totalPages}
//         onClick={() => handlePageChange(page + 1)}
//       >
//         Next
//       </Button>
//     </Box>
//   );
// };

// export default AssignmentPagination;
import React from "react";

const AssignmentPagination = ({ page, totalPages, handlePageChange }) => {

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (page <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (page >= totalPages - 2) {
        pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
      }
    }
    return pages;
  };

  return (
    <div className="pd-pagination">

      {/* Previous */}
      <button
        className="btn-negative"
        disabled={page === 1}
        onClick={() => handlePageChange(page - 1)}
      >
        Previous
      </button>

      {/* Page Numbers */}
      <div className="pd-page-numbers">
        {renderPageNumbers().map((pageNum, index) => (
          <button
            key={index}
            disabled={pageNum === "..."}
            onClick={() =>
              typeof pageNum === "number" && handlePageChange(pageNum)
            }
            className={`pg-type-btn ${pageNum === page ? "active" : ""}`}
          >
            {pageNum}
          </button>
        ))}
      </div>

      {/* Next */}
      <button
        className="btn-negative"
        disabled={page === totalPages}
        onClick={() => handlePageChange(page + 1)}
      >
        Next
      </button>

    </div>
  );
};

export default AssignmentPagination;
